var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84286 7.84344 4 9.87827 4 12C4 14.1217 4.84286 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z",
    fill: "#142038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.923 8.52588H9.077C7.93 8.52588 7 9.44588 7 10.5799V13.4699C7 14.6049 7.93 15.5239 9.077 15.5239H14.923C16.07 15.5239 17 14.6039 17 13.4699V10.5799C17 9.44488 16.07 8.52588 14.923 8.52588ZM13.519 12.1659L10.784 13.4559C10.7673 13.4638 10.7488 13.4673 10.7303 13.4662C10.7119 13.4651 10.694 13.4593 10.6783 13.4495C10.6627 13.4396 10.6498 13.4259 10.6408 13.4098C10.6318 13.3936 10.6271 13.3754 10.627 13.3569V10.6969C10.6272 10.6781 10.6321 10.6597 10.6414 10.6435C10.6507 10.6272 10.6639 10.6135 10.68 10.6038C10.696 10.5941 10.7142 10.5886 10.733 10.5879C10.7517 10.5872 10.7703 10.5914 10.787 10.5999L13.521 11.9699C13.602 12.0119 13.601 12.1269 13.519 12.1659Z",
    fill: "#142038"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.88910bbdaaf67fe599b9fab3c0127592.svg";
export { ForwardRef as ReactComponent };